import { Routes } from "~/constants/request";

enum PageNames {
  SRP = "SRP",
  RBP = "RBP",
  SHOPPING_LIST = "Shopping List",
  SHOPPING_BAG = "shopping_bag",
  CC_LANDING_PAGE = "CC Landing Page",
}
export const getPageNameByRoute = (pathname: string): string => {
  switch (pathname) {
    case Routes.SEARCH:
      return PageNames.SRP;
    case Routes.RBP:
      return PageNames.RBP;
    case Routes.SHOPPING_LIST:
      return PageNames.SHOPPING_LIST;
    case Routes.SHOPPING_BAG:
      return PageNames.SHOPPING_BAG;
    default:
      return PageNames.CC_LANDING_PAGE;
  }
};
